import { HttpHelper, HttpServiceParams } from '@ppvrbh/merchant-frontend-core';
import { MART_CATEGORY_REQUEST_ID_LIST } from './martCategory-constant';

class MartCategoryServiceClass {
  getMartTag = async () => {
    return await HttpHelper.get({
      url: 'v1/merchant/company-admin/products/tags',
      id: MART_CATEGORY_REQUEST_ID_LIST.GET_MART_TAG
    });
  }

  getMartCategory = async () => {
    return await HttpHelper.get({
      url: 'v1/merchant/company-admin/product-categories/landing',
      id: MART_CATEGORY_REQUEST_ID_LIST.GET_MART_CATEGORY
    });
  }

  postMartCategory = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v1/merchant/company-admin/product-categories',
      data: params.data,
      id: MART_CATEGORY_REQUEST_ID_LIST.POST_MART_CATEGORY,
    });
  }

  deleteMartCategory = async (params: HttpServiceParams) => {
    return await HttpHelper.delete({
      url: 'v1/merchant/company-admin/product-categories',
      config: {
        data: {
          productCategoryMerchantId: params.data,
        },
      },
      id: MART_CATEGORY_REQUEST_ID_LIST.DELETE_MART_CATEGORY,
    });
  }

  getMasterMartCategory = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: 'v1/merchant/company-admin/product-categories',
      config: { params: { isPromotionCategory: params.data } },
      id: MART_CATEGORY_REQUEST_ID_LIST.GET_MASTER_MART_CATEGORY,
    });
  }

  postTransferMartCategory = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v1/merchant/company-admin/products/transfer',
      data: params.data,
      id: MART_CATEGORY_REQUEST_ID_LIST.POST_TRANSFER_MART_CATEGORY,
    });
  }
}

export const MartCategoryService = new MartCategoryServiceClass();
